export enum TextVariant {
  Heading = "heading",
  Subheading = "subheading",
  Body = "body",
  BodyEmphasized = "bodyEmphasized",
  Caption = "caption",
  CaptionEmphasized = "captionEmphasized",
}
